(function(){
  if (window.__pmEntrega) return;
  window.__pmEntrega = true;
  var D = 86400000;
  var fijos = ['1-1','5-1','6-7','6-29','7-23','7-28','7-29','8-6','8-30','10-8','11-1','12-8','12-9','12-25'];
  function pascua(y){var a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),mes=Math.floor((h+l-7*m+114)/31),dia=((h+l-7*m+114)%31)+1;return Date.UTC(y,mes-1,dia);}
  function feriado(t){var x=new Date(t);if(fijos.indexOf((x.getUTCMonth()+1)+'-'+x.getUTCDate())>-1)return true;var p=pascua(x.getUTCFullYear());return t===p-3*D||t===p-2*D;}
  function habil(t){return new Date(t).getUTCDay()!==0&&!feriado(t);}
  function texto(){
    var o={};
    new Intl.DateTimeFormat('en-US',{timeZone:'America/Lima',year:'numeric',month:'numeric',day:'numeric',hour:'numeric',hourCycle:'h23'}).formatToParts(new Date()).forEach(function(p){if(p.type!=='literal')o[p.type]=parseInt(p.value,10);});
    var hoy=Date.UTC(o.year,o.month-1,o.day),dw=new Date(hoy).getUTCDay(),corte=dw===6?13:18,i=0;
    if(!(habil(hoy)&&o.hour<corte)){i=1;while(!habil(hoy+i*D))i++;}
    var dias=['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
    return i===0?'Llega hoy':(i===1?'Llega mañana':'Llega el '+dias[new Date(hoy+i*D).getUTCDay()]);
  }
  var t=texto();
  function run(){document.querySelectorAll('.pm-llega').forEach(function(e){if(e.textContent!==t)e.textContent=t;});}
  if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
  new MutationObserver(run).observe(document.documentElement,{childList:true,subtree:true});
})();
